import { fetchOptions } from './csrf'

export interface AdfSetting {
  id: string | null
  enabled: boolean
  adf_email: string | null
  auto_response_enabled: boolean
  response_template: string | null
  notification_emails: string[]
  created_at: string | null
  updated_at: string | null
}

interface AdfSettingResponse {
  adf_setting: AdfSetting
}

interface ErrorResponse {
  errors: string[]
}

export const adfSettingsApi = {
  async show(): Promise<AdfSetting> {
    const response = await fetch('/api/v1/settings/ilm', fetchOptions())
    if (!response.ok) throw new Error('Failed to load ILM/ADF settings')
    const data: AdfSettingResponse = await response.json()
    return data.adf_setting
  },

  async update(params: Partial<Omit<AdfSetting, 'id' | 'created_at' | 'updated_at'>>): Promise<AdfSetting> {
    const response = await fetch('/api/v1/settings/ilm', {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ adf_setting: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update settings'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: AdfSettingResponse = await response.json()
    return data.adf_setting
  },
}
